import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { RoleCreateComponent } from './create/role-create.component';
import { RoleFormComponent } from './form/role-form.component';
import { RoleListComponent } from './list/role-list.component';
import { RoleRestService } from './role-rest.service';
import { RoleRoutingModule } from './role-routing.module';
import { RoleUpdateComponent } from './update/role-update.component';

export const PROVIDERS = [RoleRestService];

@NgModule({
  imports: [
    BsDropdownModule,
    CheckboxModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    RoleRoutingModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule
  ],
  declarations: [
    RoleCreateComponent,
    RoleFormComponent,
    RoleListComponent,
    RoleUpdateComponent
  ]
})
export class RoleModule {}
